"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames_1 = require("../../../utilities/classNames");
var formCore_1 = require("../formCore");
var validationWrapper_1 = require("../validationWrapper");
var icon_1 = require("./../../display/icon");
var TextInput = /** @class */ (function (_super) {
    tslib_1.__extends(TextInput, _super);
    function TextInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextInput.prototype.focus = function () {
        if (this.input) {
            this.input.focus();
        }
    };
    TextInput.prototype.blur = function () {
        if (this.input) {
            this.input.blur();
        }
    };
    TextInput.prototype.select = function () {
        if (this.input) {
            this.input.select();
        }
    };
    TextInput.prototype.componentDidMount = function () {
        if (this.props.componentDidMount) {
            this.props.componentDidMount(this);
        }
    };
    TextInput.prototype.render = function () {
        var _this = this;
        var validationMessage = formCore_1.DataValidationMessage.get(this.props);
        var _a = this.props, className = _a.className, readonly = _a.readonly, rightOverlayText = _a.rightOverlayText, leftOverlayText = _a.leftOverlayText, type = _a.type, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, multiLine = _a.multiLine, validationMode = _a.validationMode, placeholder = _a.placeholder, children = _a.children, attrs = tslib_1.__rest(_a, ["className", "readonly", "rightOverlayText", "leftOverlayText", "type", "leftIcon", "rightIcon", "multiLine", "validationMode", "placeholder", "children"]);
        var classes = classNames_1.ClassHelpers.classNames("armstrong-input", "text-input", this.props.className, {
            "text-input-disabled": this.props.disabled,
            "has-text-overlay-right": rightOverlayText !== undefined,
            "has-text-overlay-left": leftOverlayText !== undefined,
            "text-input-icon-left": leftIcon !== undefined,
            "text-input-icon-right": rightIcon !== undefined,
            "show-validation": (validationMode !== "none" && validationMessage),
        });
        return (React.createElement("div", { className: classes, title: validationMessage },
            leftIcon && React.createElement(icon_1.Icon, { className: "left-icon", icon: leftIcon }),
            leftOverlayText && React.createElement("div", { className: "input-overlay-text-left" }, leftOverlayText),
            !multiLine && React.createElement("input", tslib_1.__assign({}, attrs, { ref: function (r) { return _this.input = r; }, type: type || "text", readOnly: readonly, placeholder: placeholder, required: this.props.required })),
            multiLine && React.createElement("textarea", tslib_1.__assign({}, attrs, { ref: function (r) { return _this.input = r; }, readOnly: readonly, placeholder: placeholder })),
            rightOverlayText && React.createElement("div", { className: "input-overlay-text-right" }, rightOverlayText),
            rightIcon && React.createElement(icon_1.Icon, { className: "right-icon", icon: rightIcon }),
            children,
            React.createElement(validationWrapper_1.ValidationLabel, { message: validationMessage, mode: validationMode })));
    };
    TextInput.defaultProps = {
        validationMode: "none",
    };
    return TextInput;
}(React.Component));
exports.TextInput = TextInput;
